var parseType = function(buffer) {
  var result = '';
  result += String.fromCharCode(buffer[0]);
  result += String.fromCharCode(buffer[1]);
  result += String.fromCharCode(buffer[2]);
  result += String.fromCharCode(buffer[3]);
  return result;
};


module.exports = parseType;



//////////////////
// WEBPACK FOOTER
// ./~/mux.js/lib/mp4/parse-type.js
// module id = 31
// module chunks = 0